document.addEventListener('alpine:init', () => {
    Alpine.store('search', {
        isOpen: false,
        toggleFind() {
            this.isOpen = !this.isOpen;
        }
    });

    Alpine.data('searchComponent', () => ({
        query: '',
        results: [],

        async fetchResults() {
            if (this.query.length < 3) {
                this.results = [];
                return;
            }

            try {
                const response = await fetch(`/api/v1/search?query=${encodeURIComponent(this.query)}`);
                const data = await response.json();
                this.results = Object.values(data).map(item => ({
                    title: item.title,
                    url: item.url
                }));
            } catch (error) {
            }
        },

        storeClickedText(text) {
            sessionStorage.setItem('clickedText', text);
            sessionStorage.setItem('query', this.query);
        }
    }));

    const clickedText = sessionStorage.getItem('clickedText');

    if (clickedText) {
        const trimmedClickedText = clickedText.trim().replace(/\s+/g, ' ').toLowerCase();

        function normalizeText(text) {
            return text.trim()
                .replace(/\s+/g, ' ')
                .toLowerCase()
                .replace(/[\u200B-\u200D\uFEFF]/g, '');
        }

        function isDisplayed(element) {
            return window.getComputedStyle(element).display !== 'none';
        }

        function getTextCoordinates(element, searchText) {
            const walker = document.createTreeWalker(
                element,
                NodeFilter.SHOW_TEXT,
                {
                    acceptNode: (node) => {
                        if (!node.textContent.trim() || ['SCRIPT', 'STYLE', 'NOSCRIPT'].includes(node.parentElement?.tagName)) {
                            return NodeFilter.FILTER_REJECT;
                        }
                        return NodeFilter.FILTER_ACCEPT;
                    }
                }
            );

            let node;
            let startNode, endNode, startOffset, endOffset;

            const foundPositions = [];

            while (node = walker.nextNode()) {
                if (!isDisplayed(node.parentElement)) continue;

                const nodeText = normalizeText(node.textContent);
                const index = nodeText.indexOf(normalizeText(searchText));

                if (index !== -1) {
                    startNode = node;
                    endNode = node;
                    startOffset = index;
                    endOffset = startOffset + searchText.length;

                    const range = document.createRange();
                    range.setStart(startNode, startOffset);
                    range.setEnd(endNode, endOffset);
                    const rect = range.getBoundingClientRect();

                    foundPositions.push({
                        rect: rect,
                        startNode: startNode,
                        endNode: endNode,
                        text: nodeText.substring(startOffset, endOffset)
                    });
                }
            }

            return foundPositions;
        }

        function searchElements(element) {
            const positions = getTextCoordinates(element, trimmedClickedText);
            if (positions.length > 0) {
                return positions;
            }

            for (const child of element.children) {
                const result = searchElements(child);
                if (result && result.length > 0) {
                    return result;
                }
            }

            return [];
        }

        const foundCoords = searchElements(document.body);

        if (foundCoords.length > 0) {
            let scrollTriggered = false;

            foundCoords.forEach((item, index) => {

                if (item.rect.top === 0 || item.rect.left === 0) {
                    return;
                }

                if (!scrollTriggered) {
                    const offset = Math.min(window.innerHeight * 0.2, 150);
                    const optimalScrollPosition = Math.max(item.rect.top + window.scrollY - offset, 0);

                    window.scrollTo({
                        top: optimalScrollPosition,
                        behavior: 'smooth'
                    });

                    scrollTriggered = true;
                }

                setTimeout(() => {
                    const range = document.createRange();
                    range.setStart(item.startNode, item.rect.left);
                    range.setEnd(item.endNode, item.rect.right);
                    const span = document.createElement('span');
                    span.style.backgroundColor = 'yellow';
                    span.style.outline = '2px solid red';

                    range.deleteContents();
                    range.insertNode(span);
                    span.textContent = item.text;

                    setTimeout(() => {
                        if (span.parentNode) {
                            const textNode = document.createTextNode(span.textContent);
                            span.parentNode.replaceChild(textNode, span);
                        }
                    }, 2000);
                }, 100);
            });

            sessionStorage.removeItem('clickedText');
            sessionStorage.removeItem('query');
        } else {
        }
    }
});
